
module.exports = {"attributes":{"viewBox":"0 0 32 32"},"content":"<rect x=\"5\" y=\"15\" width=\"22\" height=\"3\"></rect>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
